import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const MetodoPagoService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Metodo_Pago_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_metodo_pago: null,
			metodo_pago: form.metodo_pago,
			abreviacion: form.abreviacion,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Metodo_Pago_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_metodo_pago: form.id_cat_metodo_pago,
			metodo_pago: form.metodo_pago,
			abreviacion: form.abreviacion,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Metodo_Pago_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_metodo_pago) => {
		let params = {
			id_cat_metodo_pago: id_cat_metodo_pago
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Metodo_Pago_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
